/* tslint:disable */
import {
  Language,
  Translation
} from '../index';

declare var Object: any;
export interface ResourceInterface {
  "key"?: string;
  "value"?: any;
  "type"?: string;
  "colorMix"?: any;
  "id"?: any;
  "languageId"?: any;
  language?: Language;
  translations?: Translation[];
}

export class Resource implements ResourceInterface {
  "key": string;
  "value": any;
  "type": string;
  "colorMix": any;
  "id": any;
  "languageId": any;
  language: Language;
  translations: Translation[];
  constructor(data?: ResourceInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Resource`.
   */
  public static getModelName() {
    return "Resource";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Resource for dynamic purposes.
  **/
  public static factory(data: ResourceInterface): Resource{
    return new Resource(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Resource',
      plural: 'resources',
      path: 'resources',
      idName: 'id',
      properties: {
        "key": {
          name: 'key',
          type: 'string'
        },
        "value": {
          name: 'value',
          type: 'any'
        },
        "type": {
          name: 'type',
          type: 'string'
        },
        "colorMix": {
          name: 'colorMix',
          type: 'any'
        },
        "id": {
          name: 'id',
          type: 'any'
        },
        "languageId": {
          name: 'languageId',
          type: 'any'
        },
      },
      relations: {
        language: {
          name: 'language',
          type: 'Language',
          model: 'Language',
          relationType: 'belongsTo',
                  keyFrom: 'languageId',
          keyTo: 'id'
        },
        translations: {
          name: 'translations',
          type: 'Translation[]',
          model: 'Translation',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'translationableId'
        },
      }
    }
  }
}
